//product-forms.js
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // IF SIZE NOT SELECTED + CLICK ERROR
        const $productInfo = $(this.form).closest('product-info');

        const $sizeFieldset = $productInfo.find('fieldset').filter(function () {
          const legendText = $(this).find('legend').first().text().toLowerCase();
          return legendText.includes('size');
        }).first();

        if ($sizeFieldset.length > 0) {
          const showSizeError = () => {
            $sizeFieldset.find('.size-error-message').remove();
            $sizeFieldset.append("<span class='error size-error-message'>*Please select a size.</span>");

            $sizeFieldset[0].scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          };

          const checkSizeSelected = () => {
            const selected = $sizeFieldset.find('input[type="radio"]:checked').length > 0;

            if (!selected) {
              this.submitButton.setAttribute('aria-disabled', 'true');
              this.submitButton.classList.add('disabled');
            } else {
              this.submitButton.removeAttribute('aria-disabled');
              this.submitButton.classList.remove('disabled');
              $sizeFieldset.find('.size-error-message').remove();
            }
          };

          checkSizeSelected();

          $sizeFieldset.on('change', 'input[type="radio"]', checkSizeSelected);

          this.submitButton.addEventListener('click', (e) => {
            const selected = $sizeFieldset.find('input[type="radio"]:checked').length > 0;

            if (!selected) {
              e.preventDefault();
              e.stopImmediatePropagation();
              showSizeError();
              return false;
            }
          }, true);
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        var $window = window, offset = 0;
        if ($(this.form).closest('.cart-edit').length == 1) {
          $window = $(this.form).closest('.cart-edit').find('.cart-edit-popup-body')[0];
          offset = 163;
        }

        // SIZE VALIDATION START
        const $productInfo = $(this.form).closest('product-info');
        $productInfo.find('.size-error-message').remove();

        const $sizeFieldset = $productInfo.find('fieldset').filter(function () {
          const legendText = $(this).find('legend').first().text().toLowerCase();
          return legendText.includes('size');
        }).first();

        if ($sizeFieldset.length > 0) {
          const sizeSelected = $sizeFieldset.find('input[type="radio"]:checked').length > 0;

          if (!sizeSelected) {
            $sizeFieldset.append("<span class='error size-error-message'>*Please select a size.</span>");

            var element = $sizeFieldset[0];
            var rect = element.getBoundingClientRect();

            $window.scrollBy({
              top: rect.top - 10 - offset,
              behavior: 'smooth'
            });

            return;
          }
        }
        // SIZE VALIDATION END

        // FIXED: Add empty text validation for preselected products
        if (
          $(this.form).closest('product-info').find('.preselected-textarea').length > 0 ||
          $(this.form).closest('.cart-edit').find('.preselected-textarea').length > 0
        ) {
          var $preselectedTextarea = $(this.form).closest('product-info').find('.preselected-textarea').length > 0
            ? $(this.form).closest('product-info').find('.preselected-textarea')
            : $(this.form).closest('.cart-edit').find('.preselected-textarea');

          var $errorContainer = $preselectedTextarea.closest('.parent_div');
          $errorContainer.find('.empty_error').remove();

          if ($preselectedTextarea.val() == '') {
            $errorContainer.append("<span class='error empty_error'>*Add your name.</span>");

            var element = $errorContainer[0];
            var rect = element.getBoundingClientRect();

            $window.scrollBy({
              top: rect.top - 10 - offset,
              behavior: 'smooth'
            });

            return;
          }
        }

        $(this.form).closest('product-info').find('.color_selected_error').remove();

        var check = true;
        if ($(this.form).closest('product-info').find('input[name="Add Personalization?"]:checked').val() == 'No') {
          check = false;
        }

        if (
          $(this.form).closest('product-info').find('.color-select__item.active-done').length <
          $(this.form).closest('product-info').find('.color-select__item').length &&
          check == true
        ) {
          $(this.form).closest('product-info').find('.choosen_color_wrp').append("<span class='color_selected_error'>*Select all the Color.</span>");

          $(this.form).closest('product-info').find('.color-select__item:not(.active-done)').each(function (index, val) {
            $(val).find('input').val(" ");
            $(val).addClass('color_error');
            $(val).closest('product-info').find('.preview_texts_inner').find('span').each(function (i, v) {
              if (
                ($(val).hasClass('color_error') && $(val).attr('data-index') == i) ||
                $(val).closest('product-info').find('[name="color_selected"]:checked').attr("value") == 'Each character Same Color'
              ) {
                $(v).addClass('striped-text');
              }
            });
          });

          setTimeout(function () {
            $(this.form).closest('product-info').find('.color_selected_error').remove();
          }, 2000);

          var element = $(this.form).closest('product-info').find('.color-select__wrapper')[0];
          var rect = element.getBoundingClientRect();
          var stickyOffset = $(this.form).closest('product-info').find('.preview_texts').outerHeight();

          if (
            rect.top < stickyOffset ||
            rect.left < 0 ||
            rect.bottom > (window.innerHeight || $(window).height()) ||
            rect.right > (window.innerWidth || $(window).width())
          ) {
            $window.scrollBy({
              top: rect.top - stickyOffset - 10 - offset,
              behavior: 'smooth'
            });
          }

          return;
        }

        if ($(this.form).closest('product-info').find('.optional_generic_note').length > 0) {
          $(this.form).closest('product-info').find('.empty_error').remove();

          if (
            $(this.form).closest('product-info').find('[name="Add Personalization?"]').length > 0 &&
            $(this.form).closest('product-info').find('[name="Add Personalization?"]:checked').attr("value").toUpperCase() == "YES" &&
            $(this.form).closest('product-info').find('.optional_generic_note').val() == ''
          ) {
            $(this.form).closest('product-info').find('.optional_generic_note').parent().append("<span class='error empty_error'>*Add Personalization note.</span>");
            return;
          }
        }

        if ($(this.form).closest('product-info').find('[name="properties[Notes]"]').length > 0) {
          $(this.form).closest('product-info').find('.empty_error').remove();

          if (
            $(this.form).closest('product-info').find('[name="properties[Notes]"]').length > 0 &&
            $(this.form).closest('product-info').find('[name="Want to Personalized"]:checked').attr("value") == "Yes" &&
            $(this.form).closest('product-info').find('[name="properties[Notes]"]').val() == ''
          ) {
            $(this.form).closest('product-info').find('[name="properties[Notes]"]').parent().append("<span class='error empty_error'>*Add your name.</span>");

            var element = $(this.form).closest('product-info').find('.empty_error').closest('.parent_div')[0];
            var rect = element.getBoundingClientRect();

            $window.scrollBy({
              top: rect.top - 10 - offset,
              behavior: 'smooth'
            });

            return;
          }

          if (
            $(this.form).closest('product-info').find('[name="properties[Notes]"]').length > 0 &&
            $(this.form).closest('product-info').find('.custom_generic_note').length > 0
          ) {
            if ($(this.form).closest('product-info').find('[name="properties[Notes]"]').val() == '') {
              $(this.form).closest('product-info').find('[name="properties[Notes]"]').parent().append("<span class='error empty_error'>*Add your personalisation.</span>");

              var element = $(this.form).closest('product-info').find('.empty_error').closest('.parent_div')[0];
              var rect = element.getBoundingClientRect();

              $window.scrollBy({
                top: rect.top - 10 - offset,
                behavior: 'smooth'
              });

              return;
            }
          }
        }

        if (
          $(this.form).closest('product-info').find('.personalization_note').length > 0 &&
          $(this.form).closest('.product-card-wrapper').length == 0 &&
          $(this.form).closest('product-info').find('input[name="Add Personalization?"]:checked').length > 0
        ) {
          if ($(this.form).closest('product-info').find('input[name="Add Personalization?"]:checked').attr("value").toUpperCase() != 'NO') {
            $(this.form).closest('product-info').find('.empty_error').remove();

            if (
              $(this.form).closest('product-info').find('.personalization_note').length > 0 &&
              $(this.form).closest('product-info').find('.personalization_note').val() == ''
            ) {
              $(this.form).closest('product-info').find('.personalization_note').parent().append("<span class='error empty_error'>*Add your name.</span>");

              var element = $(this.form).closest('product-info').find('.empty_error').closest('.parent_div')[0];
              var rect = element.getBoundingClientRect();

              $window.scrollBy({
                top: rect.top - 10 - offset,
                behavior: 'smooth'
              });

              return;
            }
          }
        }

        if (
          $(this.form).closest('.cart-edit').length == 1 &&
          ($(this.form).closest('product-info').find('.color-select__item.active-done').length <
            $(this.form).closest('product-info').find('.color-select__item').length) &&
          $(this.form).closest('product-info').find('[name="color_selected"]:checked').val() == 'Each Character Different Color'
        ) {
          $('.cart-edit').find('.color-select__item:not(.active-done)').each(function (index, val) {
            $(val).find('input').val("-");
          });
        }

        var loadingbar = document.querySelector(".loading-bar");
        var loadingbarinner = document.querySelector(".loading-bar-inner");

        loadingbar.classList.add("is-visible");
        loadingbarinner.style.transform = "scaleX(0.4)";

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            loadingbarinner.style.transform = "scaleX(1)";

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;

              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }

            $('.cart-edit .cart-edit_popup-close').trigger('click');

            if (window.location.pathname.indexOf('/cart') > -1) {
              window.location.reload();
            }
          })
          .catch((e) => {
            console.error(e);

            setTimeout(function () {
              loadingbar.classList.remove("is-visible");
              loadingbarinner.style.transform = "scaleX(0)";
            }, 1000);
          })
          .finally(() => {
            setTimeout(function () {
              loadingbar.classList.remove("is-visible");
              loadingbarinner.style.transform = "scaleX(0)";
            }, 1000);

            this.submitButton.classList.remove('loading');

            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) this.submitButton.removeAttribute('aria-disabled');

            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
} 